import { render, staticRenderFns } from "./OpenProductBatch.vue?vue&type=template&id=899ffac4&scoped=true&"
import script from "./OpenProductBatch.vue?vue&type=script&lang=js&"
export * from "./OpenProductBatch.vue?vue&type=script&lang=js&"
import style0 from "./OpenProductBatch.vue?vue&type=style&index=0&id=899ffac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ffac4",
  null
  
)

export default component.exports